import { useTranslation } from 'react-i18next'

export const LabelGeneratingBanner = () => {
  const { t } = useTranslation()

  return (
    <section
      role="status"
      className="w-full space-y-1 border-l-2 border-blue-400 bg-blue-50 p-5 shadow-sm"
    >
      <p className="text-sm font-medium text-neutral-900">
        {t('tracking_new.label_banner_title')}
      </p>
      <p className="text-xs font-normal leading-relaxed text-neutral-700">
        {t('tracking_new.label_banner_body')}
      </p>
    </section>
  )
}
